import { Chip, Stack, styled } from '@mui/material';

type Props = {
  data: string[];
  onChange: (value?: string) => void;
};

const StyledChip = styled(Chip)(({ theme }) => ({
  '&.MuiChip-clickable:hover': {
    backgroundColor: 'transparent',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
}));

function BadFeedback({ data, onChange }: Props) {
  return (
    <Stack spacing={1} direction="row" flexWrap="wrap" data-testid="bad-feedback-chips">
      {data.map((feedback) => (
        <StyledChip
          className="bad-feedback-chip"
          key={feedback}
          variant="outlined"
          label={feedback}
          clickable
          onClick={() => onChange(feedback)}
        />
      ))}
    </Stack>
  );
}

export default BadFeedback;
